import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-navy text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-24 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <div className="inline-block bg-white px-5 py-3 mb-5">
            <img
              src="https://customer-assets.emergentagent.com/job_nautical-polos/artifacts/8xxylszx_DC6D1D5E-BA1A-4F52-B0D9-C64358C3561C.png"
              alt="Boat 2 Tee"
              className="h-20 w-auto"
            />
          </div>
          <p className="text-white/60 text-sm leading-relaxed max-w-xs">
            Coastal apparel for life on the water and the course. Built for the people who chase tides and tee times.
          </p>
          <div className="flex items-center gap-3 mt-6">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="footer-instagram" className="p-2 border border-white/15 hover:border-seafoam hover:text-seafoam transition-colors">
              <Instagram className="w-4 h-4" strokeWidth={1.5} />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer" data-testid="footer-facebook" className="p-2 border border-white/15 hover:border-seafoam hover:text-seafoam transition-colors">
              <Facebook className="w-4 h-4" strokeWidth={1.5} />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" data-testid="footer-youtube" className="p-2 border border-white/15 hover:border-seafoam hover:text-seafoam transition-colors">
              <Youtube className="w-4 h-4" strokeWidth={1.5} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-[11px] font-bold uppercase tracking-[0.24em] text-seafoam mb-5">Shop</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/collections/premium-hoodies" className="hover:text-white">Premium Hoodies</Link></li>
            <li><Link to="/collections/performance-hoodies" className="hover:text-white">Performance Hoodies</Link></li>
            <li><Link to="/collections/coastal-polos" className="hover:text-white">Polos</Link></li>
            <li><Link to="/collections/premium-hats" className="hover:text-white">Hats</Link></li>
            <li><Link to="/collections/womens" className="hover:text-white">Women's</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[11px] font-bold uppercase tracking-[0.24em] text-seafoam mb-5">Brand</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/about" className="hover:text-white">Our Story</Link></li>
            <li><a href="#reviews" className="hover:text-white">Reviews</a></li>
            <li><a href="#newsletter" className="hover:text-white">Newsletter</a></li>
            <li><a href="mailto:hello@boat2tee.com" className="hover:text-white">Contact</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[11px] font-bold uppercase tracking-[0.24em] text-seafoam mb-5">Help</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><a href="#" className="hover:text-white">Shipping</a></li>
            <li><a href="#" className="hover:text-white">Returns</a></li>
            <li><a href="#" className="hover:text-white">Size Guide</a></li>
            <li><a href="#" className="hover:text-white">Privacy</a></li>
            <li><a href="#" className="hover:text-white">Terms</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} Boat 2 Tee. All rights reserved.</p>
          <p className="text-xs text-white/40 tracking-widest uppercase">Tee Off · Tide Out</p>
        </div>
      </div>
    </footer>
  );
};
